import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import userImg from "../../assets/images/users/AdminImg.png";
import { Scheduler, View, Editing } from "devextreme-react/scheduler";
import "devextreme/dist/css/dx.light.css";
import moment from "moment";
import timezone from "moment-timezone";
import "../../assets/css/Calender/Devcalender.css";
import "../../assets/css/Calender/Calender.css";
import axios from "axios";
import configure from "configure";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { aryIanaTimeZones, timeSlots } from "utils/common-options";
import { useSelector } from "react-redux";
import {
  checkPermissionsByModule,
  parseDateTimeSlot,
} from "utils/common-helpers";
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
  FetchPostData,
} from "utils/common-fetchData";
import { Tooltip } from "antd";
import Loader from "components/Common/Loader";
import Breadcrumb from "components/Common/Breadcrumb";

export function copyToClipBoard(e) {
  if (e !== null) {
    window.navigator.clipboard.writeText(e);
  }
}

const CalenderIndex = () => {
  const [currentDate, setCurrentDate] = useState(moment());
  const [scrolled, setScrolled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isImp, setIsImp] = useState(0);
  const [Addmeeting, setAddmeeting] = useState(false);
  const [allBookingData, setAllBookingData] = useState([]);
  const [type, setType] = useState("");

  // Add meeting states

  const [addTitle, setAddTitle] = useState("");
  const [crrlocation, setCrrlocation] = useState("");
  const [addAttendees, setAddAttendees] = useState(null);
  const [addDate, setAddDate] = useState("");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [addDescription, setAddDescription] = useState("");
  const [meetingFor, setMeetingFor] = useState([]);
  const [meetingForSub, setMeetingForSub] = useState([{}]);
  const [meetingForSubset, setMeetingForSubset] = useState(null);
  const [modal_Access, setAccessDenied] = useState(false);
  const [ismeetingFor, setIsmeetingFor] = useState(false);
  const [meetingForLabel, setMeetingForLabel] = useState("");
  const [link, setLink] = useState("");
  const [mettingId, setMeetingId] = useState("");
  const timezonemoment = timezone.tz.guess();
  const [selectedTimeZone, setSelectedTimeZone] = useState([]);
  const recuringOption = [
    {
      value: 0,
      label: "All Day",
    },
    {
      value: 1,
      label: "Monday",
    },
    {
      value: 2,
      label: "Tuesday",
    },
    {
      value: 3,
      label: "Wednesday",
    },
    {
      value: 4,
      label: "Thursday",
    },
    {
      value: 5,
      label: "Friday",
    },
    {
      value: 6,
      label: "Saturday",
    },
    {
      value: 7,
      label: "Sunday",
    },
  ];

  const [selectedStaff, setSelectedStaff] = useState([]);
  const { id } = useParams();
  const token = secureLocalStorage.getItem("Token");
  // ...............................................................

  const schedulerRef = useRef(null);
  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 1200,
    }),
  };
  const customStyles2 = {
    control: (provided) => ({
      ...provided,
      paddingLeft: "2.5rem", // Add padding to the left of the control
    }),
    input: (provided) => ({
      ...provided,
      marginLeft: "0", // Add padding to the left of the input cursor
    }),
    menuList: (styles) => ({
      ...styles,
      background: "white",
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 1200,
    }),
  };

  const meetingForOption = [
    // { value: 1, label: "Project", type: 1 },
    { value: 2, label: "Lead", type: 2 },
    { value: 4, label: "Customer", type: 4 },
    { value: 5, label: "Other", type: 0 },
    { value: 6, label: "Internal", type: 5 },
  ];

  useEffect(() => {
    if (id) {
      const [type, paramid] = id?.split("-") || [];
      const meeting = { value: 2, label: type, type: 2 };
      setMeetingFor(meeting);
      setIsmeetingFor(true);
      handleMeetingFor(meeting, paramid);
    }
    const locations = secureLocalStorage?.getItem("User");
    setCrrlocation(locations?.location);
  }, []);

  const [timeSlotsOption, setTimeSlotsOption] = useState([]);
  const [recurring_day, setReccuringDay] = useState([]);
  const [recurring, setRecurring] = useState(false);
  const isAllSelected = recurring_day.some((opt) => opt.value === "0");
  const isOtherSelected = recurring_day.some((opt) => opt.value !== "0");
  const options = recuringOption.map((opt) => ({
    ...opt,
    isDisabled: isAllSelected
      ? opt.value !== "0"
      : isOtherSelected && opt.value === "0",
  }));
  useEffect(() => {
    setTimeSlotsOption(timeSlots);
    setSelectedTimeZone({
      label: timezonemoment,
      value: timezonemoment,
    });
  }, []);

  const toggleaddmeeting = () => {
    setAddmeeting(!Addmeeting);
    setType(Addmeeting ? "" : type);
    setAddTitle("");
    setAddDescription("");
    setSelectedAttendees([]);
    setAddAttendees(null);
    setIsImp(0);
    setMeetingFor([]);
    setMeetingForSub([{}]);
    setMeetingForSubset(null);
    setIsmeetingFor(false);
    setMeetingForLabel("");
    setReccuringDay([]);
    setRecurring(false);
    setLink("");
  };

  useEffect(() => {
    if (schedulerRef.current) {
      const schedulerInstance = schedulerRef.current.instance;

      const customizeAppointmentCollector = () => {
        schedulerInstance.on("contentReady", () => {});
      };

      customizeAppointmentCollector();
    }
  }, []);

  document.title = "Calender | Zithas Crm";

  const handlePropertyChange = useCallback((e) => {
    if (e?.name === "currentDate") {
      setCurrentDate(e?.value);
    }
  }, []);
  async function handleAppointmentClick(obj) {
    const ids = obj?.targetedAppointmentData?.user_id?.split(",");
    const isInvolve = obj?.targetedAppointmentData?.introducer_id == secureLocalStorage.getItem('User')?.id
    if (isInvolve) {
      setType("edit");
      setIsImp(obj?.targetedAppointmentData?.is_imp);
      setLink(obj?.targetedAppointmentData?.meeting_link);
      setRecurring(obj?.targetedAppointmentData?.recurring == 1);
      const optionIds =
        obj?.targetedAppointmentData?.recurring_days?.split(",");
      const resultDay = recuringOption?.filter((opt) =>
        optionIds?.includes(String(opt.value))
      );
      setReccuringDay(resultDay);
      setMeetingId(obj?.targetedAppointmentData?.id);
      setAddTitle(obj?.targetedAppointmentData?.title);
      setSelectedTimeZone(
        timeZonesWithLabelValue?.find(
          (opt) => opt?.value == obj?.targetedAppointmentData?.timezone
        )
      );

      setAddDate(
        moment(obj?.targetedAppointmentData?.start).format("YYYY-MM-DD")
      );
      setSelectedTimeSlot(
        timeSlotsOption?.find(
          (opt) => opt?.value == obj?.targetedAppointmentData?.timeslot
        )
      );
      const result = attendOption?.filter((opt) =>
        ids?.includes(String(opt.value))
      );
      setAddDescription(obj?.targetedAppointmentData?.description);
      setAddAttendees(result);
      const meetingFor = meetingForOption?.find(
        (opt) => opt?.value == obj?.targetedAppointmentData?.project
      );
      setMeetingFor(meetingFor);
      const dat = await handleMeetingFor(
        meetingFor,
        null,
        "store",
        obj?.targetedAppointmentData
      );
      setLink(obj?.targetedAppointmentData?.meeting_link);
      setAddmeeting(true);
    }
  }

  const appointmentRender = (data) => {
    const mergedArray = data?.data?.appointmentData.user_details;
    const ids = data?.data?.appointmentData?.user_id?.split(",");
    const isInvolve = data?.data?.appointmentData?.introducer_id == secureLocalStorage.getItem('User')?.id

    const bgColorMap = {
      1: "#971f77", // Project - Light Cyan
      2: "#8939aa", // Lead - Light Orange
      3: "#fed43c", // Introducer - Light Purple
      4: "#228001", // Customer - Light Green
      5: "#556ee6", // Other - Light Coral/Peach
      6: "#50a5f1", // Other - Light Coral/Peach
      7: "#f975f1", // Other - Light Coral/Peach
    };
    const backgroundColor =
      bgColorMap[data?.data?.appointmentData?.project] || "#FFFFFF"; // de

    const start = data?.data?.targetedAppointmentData?.displayStartDate;
    const end = data?.data?.targetedAppointmentData?.displayEndDate;

    const formattedTimeSlot = `${moment(start)
      ?.tz(timezonemoment)
      ?.format("hh:mm A")} - ${moment(end)
      ?.tz(timezonemoment)
      ?.format("hh:mm A")}`;

    const selectedTimeSlots = `${moment(start)
      .tz(data?.data?.targetedAppointmentData?.timezone)
      ?.format("hh:mm A")} - ${moment(end)
      .tz(data?.data?.targetedAppointmentData?.timezone)
      ?.format("hh:mm A")}`;

    const isOtherTime =
      data?.data?.targetedAppointmentData?.timezone != timezonemoment;
    const otherTime = isOtherTime ? selectedTimeSlots : null;

    const tooltipContent = (
      <div className="d-flex gap-2 p-0 text-purple fw-bold body-font fs-6">
        <div className="dot-box"></div>
        <div>
          <div className="dx-tooltip-appointment-item-content-subject">
            {isInvolve ? data?.data?.appointmentData?.title : "Online Meeting"}
          </div>
          <small className="dx-tooltip-appointment-item-content-date">
            {/* {data?.data?.targetedAppointmentData?.timeslot} */}
            Local : {formattedTimeSlot}
            <br /> {otherTime != null ? `UTC : ${otherTime}` : null}
          </small>
          <div>
            {data?.data?.targetedAppointmentData?.meeting_link != null &&
            data?.data?.targetedAppointmentData?.meeting_link != "" ? (
              <a
                target="_blank"
                href={data?.data?.targetedAppointmentData?.meeting_link}
                rel="noreferrer"
              >
                <small className="dx-tooltip-appointment-item-content-date">
                  {data?.data?.targetedAppointmentData?.meeting_link?.slice(
                    0,
                    20
                  ) + " ...."}
                </small>
              </a>
            ) : null}
          </div>
        </div>
      </div>
    );
    const appointmentDateStr = data?.data?.appointmentData?.start; // Replace with actual date path
    const appointmentDate = new Date(appointmentDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    appointmentDate.setHours(0, 0, 0, 0);

    const isPast = appointmentDate < today;
    return (
      <div
        style={{ backgroundColor }}
        className={`${
          isPast ? "text-content-default-past" : "text-content-default "
        } border-start border-2 border-white  h-100 overflow-y-visible `}
      >
        <Tooltip color="#f0e8f4" title={tooltipContent}>
          <div className="hover-container ">
            <div className="d-flex justify-content-between ">
              <div className="">
                <span
                  style={{ fontSize: "12px" }}
                  className="text-capitalize fw-bold"
                >
                  {isInvolve
                    ? data?.data?.appointmentData?.title?.slice(0, 10) + " ..."
                    : "Online Meeting"}
                </span>
              </div>
              <div>
                <span>
                  {mergedArray?.map((ob, i) => {
                    return (
                      <img
                        key={i + 1}
                        className="rounded-circle bg-secondary"
                        src={
                          ob.avatar && ob.avatar !== "-"
                            ? `${configure.imgUrl}${ob.avatar}`
                            : userImg
                        }
                        width={17}
                        height={17}
                        title={ob.alias_name}
                        alt=""
                        style={{ marginLeft: "0px" }}
                      />
                    );
                  })}
                </span>
              </div>
            </div>
          </div>
        </Tooltip>
      </div>
    );
  };

  const fetch = async () => {
    setLoading(true);
    try {
      const bearerToken = secureLocalStorage.getItem("auth_token");
      const locations = secureLocalStorage?.getItem("User");
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/calenderaccess/introducer/options/${locations?.id}`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        const allStaffOption = response.data.data.map((obj) => {
          return {
            label: obj?.alias_name,
            value: obj.id,
            ...obj,
          };
        });

        setAllStaffDatas(allStaffOption);
        setAttendOption(allStaffOption);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const checkElement = () => {
    const scrollTimeIndicator = document.querySelector(
      ".dx-scheduler-date-time-indicator"
    );

    if (scrollTimeIndicator) {
      const viewportHeight = window.innerHeight;
      const rect = scrollTimeIndicator.getBoundingClientRect();
      const scrollPosition =
        rect.top - viewportHeight / 2 + rect.height / 2 - -70;

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    checkElement();
  }, []);

  const getMeetings = async (selectedStaff) => {
    const formEntries = {
      id: selectedStaff?.map((obj) => obj?.value),
      introducer_id: secureLocalStorage.getItem('User')?.id,
    };
    const res = await FetchNodePostData(
      toggleLoading,
      `/calender/introducer/get`,
      token,
      formEntries
    );
    if (res?.status) {
      const meetData = res.data?.data?.map((teamItem, index) => {
        return {
          id: index + 1,
          title: teamItem.title,
          date: moment(teamItem.start.dateTime),
          link: teamItem.onlineMeeting?.joinUrl,
          timeslot: teamItem?.timeslot,
          classNames: "bg-calender-content h-100",
          startDate: teamItem?.start,
          endDate: teamItem?.end,
          ...teamItem,
        };
      });
      setAllBookingData(meetData);
    }
  };

  useEffect(() => {
    fetch();
    getMeetings([]);
  }, []);

  const timeZonesWithLabelValue = aryIanaTimeZones.map((timeZone) => ({
    label: timeZone,
    value: timeZone,
  }));

  const handleChange = (selectedOption) => {
    setSelectedTimeSlot(selectedOption);
  };
  const handleChangeAttendees = (selectedOption) => {
    setAddAttendees(selectedOption || []);
    const mappedAttendees = (selectedOption || []).map((opt) => ({
      label: opt.email,
      value: opt.email,
    }));

    setSelectedAttendees(mappedAttendees);
  };
  const handleMeetingForSubset = (obj) => {
    setMeetingForSubset(obj);
  };
  const handleMeetingFor = async (meeting, paramid, store, obj) => {
    setMeetingFor(meeting);
    setMeetingForSub([{}]);
    if (meeting?.type == 0 || meeting?.type == 5 || meeting?.type == 6) {
      setIsmeetingFor(false);
      setMeetingForLabel("");
    }
    if (meeting?.type == 4) {
      setLoading(true);
      setMeetingForLabel(meeting?.label);
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/customers`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        const modifyArray = response.data.customers.map((ob, i) => {
          const convertData = {
            value: i + 1,
            label: ob.company,
            formDataName: "customer_id",
            leadId: ob.id,
          };
          return convertData;
        });
        setIsmeetingFor(true);
        if (store == "store") {
          setMeetingForSubset(
            modifyArray?.find((opt) => opt?.value == obj?.related_to)
          );
        }
        setMeetingForSub(modifyArray);
        setLoading(false);
      }
    }

    if (meeting.type == 2) {
      setLoading(true);
      setMeetingForLabel(meeting.label);
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/leads`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        const modifyArray = response.data.leads.map((ob, i) => {
          const data = JSON.parse(ob.person_details);
          const temparrName = data[0]?.person_name
            ? data[0]?.person_name
            : "N/A";

          const convertData = {
            value: 2,
            label: `${ob.company ? ob.company : "N/A"} - ${temparrName}`,
            // label: data[0]?.person_name,
            formDataName: "lead_id",
            leadId: ob.id,
          };
          return convertData;
        });
        setIsmeetingFor(true);
        setMeetingForSub(modifyArray);
        if (store == "store") {
          setMeetingForSubset(
            modifyArray?.find((opt) => opt?.value == obj?.related_to)
          );
        }
        if (paramid != null) {
          const filterarray = modifyArray.filter((obj) => {
            return obj.leadId == paramid;
          });
          setMeetingForSubset(filterarray);
        }
        setLoading(false);
      }
    }
  };

  const roles = useSelector((state) => state?.Roles?.apiData);
  const locations = useSelector((state) => state?.location?.locations);
  const dataCellComponent = async (e) => {
    const selectedDate = moment(e?.cellData?.startDate);
    const startFromTime = moment(selectedDate).format("hh:mm A");
    const startEndTime = moment(e?.cellData?.endDate).format("hh:mm A");
    const setDate = moment(selectedDate).format("YYYY-MM-DD");
    setAddDate(setDate);
    if (setDate == moment().format("YYYY-MM-DD")) {
      if (crrlocation != null) {
        let todaySlots;
        if (crrlocation?.value == "India") {
          todaySlots = timeSlots?.filter((slot) => {
            return moment()
              .add(30, "minute")
              .isBefore(moment(slot.from, "hh:mm A"));
          });
        } else {
          todaySlots = timeSlots.filter((slot) => {
            const currentLondonTime = new Date().toLocaleString("en-US", {
              timeZone: "Europe/London",
            });
            let londonTime = new Date(currentLondonTime);
            londonTime.setMinutes(londonTime.getMinutes() + 30);
            const slotTime = parseTimeString(slot.from);
            return londonTime < slotTime;
          });
        }
        setTimeSlotsOption(todaySlots);
      } else {
        setTimeSlotsOption([]);
      }
    }
    if (selectedDate >= new Date()) {
      setAddTitle("");
      setAddDescription("");
      setSelectedAttendees([]);
      setAddAttendees([]);
      setIsImp(0);
      setMeetingFor([]);
      setMeetingForSub([{}]);
      setMeetingForSubset(null);
      setIsmeetingFor(false);
      setMeetingForLabel("");
      setAddmeeting(true);
      setReccuringDay([]);
      setRecurring(false);
    } else {
      Swal.fire({
        icon: "warning",
        text: "You cannot book a meeting for a date that is in the past.",
      });
    }

    const matchingSlot = timeSlots.filter((slot) => {
      const temp = `${startFromTime} - ${startEndTime}`;
      return slot.label.trim() == temp.trim();
    });
    if (matchingSlot.length !== 0) {
      setSelectedTimeSlot(matchingSlot[0]);
    } else {
      setSelectedTimeSlot(null);
    }
  };
  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const handleAddMeeting = async (e) => {
    e.preventDefault();
    if (
      meetingFor?.length != 0 &&
      meetingFor != null 
      // addAttendees?.length != 0 &&
      // addAttendees != null
    ) {
      const dates = parseDateTimeSlot(addDate, selectedTimeSlot?.value);
      const userId = secureLocalStorage?.getItem("User");
      const formEntries = {
        title: addTitle,
        location: crrlocation,
        timezone: selectedTimeZone?.value,
        imp: isImp,
        user_id: userId?.id,
        attendees: addAttendees?.map((obj) => obj?.value),
        aemail: selectedAttendees?.map((obj) => obj?.value),
        date: addDate,
        startDate: dates?.start,
        endDate: dates?.end,
        timeslot: selectedTimeSlot?.value,
        meeting_with: meetingFor?.value,
        related_to: meetingForSubset?.value,
        description: addDescription,
        meeting_link: link,
        recurring: recurring ? 1 : 0,
        recurring_days: recurring_day?.map((obj) => obj?.value),
        // added_from: link,
      };
      const res =
        type == "edit"
          ? await FetchNodePutData(
              toggleLoading,
              "calender/introducer/edit",
              `${mettingId}`,
              formEntries,
              token
            )
          : await FetchNodePostData(
              toggleLoading,
              "calender/introducer",
              token,
              formEntries
            );
      if (res?.status) {
        Swal.fire({
          icon: "success",
          text:
            type == "edit"
              ? "Your meeting has been successfully Updated."
              : "Your meeting has been successfully booked.",
        }).then(() => {
          setAddmeeting(false);
          getMeetings(selectedStaff);
        });
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: `${
          meetingFor?.length == 0 || meetingFor == null
            ? "Please Select Meeting With Option"
            : "Please Select mandatory fields"
        } `,
      });
    }
  };
  const [selectedAttendees, setSelectedAttendees] = useState([]);

  function parseTimeString(timeStr) {
    // Assuming timeStr is in "hh:mm A" format
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");

    hours = parseInt(hours);
    minutes = parseInt(minutes);

    if (period === "PM" && hours < 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    return date;
  }

  useEffect(() => {
    const currentDate = moment().format("YYYY-MM-DD");
    if (addDate == currentDate) {
      if (crrlocation != null) {
        let todaySlots;
        if (crrlocation.value == "India") {
          todaySlots = timeSlots.filter((slot) => {
            return moment()
              .add(30, "minute")
              .isBefore(moment(slot.from, "hh:mm A"));
          });
        } else {
          todaySlots = timeSlots.filter((slot) => {
            const currentLondonTime = new Date().toLocaleString("en-US", {
              timeZone: "Europe/London",
            });
            let londonTime = new Date(currentLondonTime);
            londonTime.setMinutes(londonTime.getMinutes() + 30);
            const slotTime = parseTimeString(slot.from);
            return londonTime < slotTime;
          });
        }
        setTimeSlotsOption(todaySlots);
      }
    } else {
      setTimeSlotsOption(timeSlots);
    }
  }, [crrlocation, addDate]);
  // get staff

  const [allStaffData, setAllStaffDatas] = useState(null);
  const [attendOption, setAttendOption] = useState(null);

  const getTodayDate = () => {
    const today = new Date();
    let month = String(today.getMonth() + 1);
    let day = String(today.getDate());
    const year = today.getFullYear();

    // Add leading zeros if needed
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${year}-${month}-${day}`;
  };

  const onDeleteMeeting = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      `calender/trash/${mettingId}`,
      token
    );
    if (response?.status) {
      Swal.fire({
        icon: "success",
        text: "Your meeting has been successfully Removed.",
      }).then(() => {
        setAddmeeting(false);
        getMeetings(selectedStaff);
      });
    }
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content ">
        <Container fluid style={{ maxWidth: "100vw" }}>
          {/* <Breadcrumb title={"Dashboard"} breadcrumbItem={"Calendar"} /> */}
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody className="p-0">
                  <div className="cover-cal"></div>
                  <div className="position-fixed filter-select-calender  d-flex gap-2 align-items-center">
                    <ReactSelect
                      placeholder="Choose Meeting Filter"
                      className="basic-multi-select col-md-11 fixed-head"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={allStaffData}
                      value={selectedStaff}
                      isMulti
                      onChange={(e) => {
                        setSelectedStaff(e);
                      }}
                    />
                    <button
                      className="btn btn-sm  bg-white text-purple me-2"
                      onClick={() => {
                        getMeetings(selectedStaff);
                      }}
                    >
                      <i className="fas fa-filter  fs-6"></i>
                    </button>
                  </div>
                  <div className={`shadow-sm ${scrolled && "fixed-calender"}`}>
                    <Scheduler
                      ref={schedulerRef}
                      timeZone={timezonemoment}
                      currentDate={currentDate}
                      onOptionChanged={handlePropertyChange}
                      
                      // textExpr="title"
                      defaultCurrentView="week"
                      recurrenceRuleExpr="recurrence"
                      dataSource={allBookingData}
                      onAppointmentClick={handleAppointmentClick}
                      appointmentComponent={appointmentRender}
                      showAllDayPanel={false}
                      onCellClick={dataCellComponent}
                    >
                      <View
                        type="day"
                        startDayHour={0}
                        endDayHour={24}
                        useNative={false}
                      />
                      <View
                        type="week"
                        startDayHour={0}
                        endDayHour={24}
                        useNative={false}
                      />
                      <View type="month" />
                      <Editing allowDragging={false} />
                    </Scheduler>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={Addmeeting}
        toggle={toggleaddmeeting}
        size="lg"
        centered
        className="meetingModal z-3"
      >
        <button
          onClick={() => {
            setAddmeeting(false);
            setType("");
            setLink("");
          }}
          id="modalToggle"
          className="modalToggle btn shadow-sm border-0"
          style={{ zIndex: "99999" }}
        >
          <i className="fas fa-times"></i>
        </button>
        <ModalBody className="modal-body border-0">
          <form onSubmit={handleAddMeeting}>
            <div className="d-flex justify-content-between mb-4">
              <div className="d-flex align-items-center col-md-8">
                <div
                  className="btn-meeting p-2 px-3 border-radius"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="bx bx-calendar-event fs-4"></i>
                </div>
                <div className="d-flex gap-2 align-items-center col-md-10">
                  <h4 className="mb-0 ps-2 col-md-4 ">
                    {type == "edit" ? "Update" : "New"} Meeting
                  </h4>
                  {/* <div className="meetToggle d-flex me-2 align-items-center ms-3">
                    <label className="mb-0">Recurring</label>
                    <div className="form-switch form-switch-md ps-5">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                        defaultChecked={recurring}
                        onChange={(e) => setRecurring(e.target.checked)}
                      />
                    </div>
                  </div>
                  <div className="col-md-7 ps-3">
                    <ReactSelect
                      placeholder="Select Days"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isMulti
                      styles={colourStyles}
                      options={options}
                      isOptionDisabled={(option) => option.isDisabled}
                      value={recurring_day}
                      onChange={setReccuringDay}
                    />
                  </div> */}
                </div>
              </div>
              <div className="me-2 ">
                {type == "edit" ? (
                  <button
                    className="btn-danger btn px-4 py-2 me-2"
                    onClick={onDeleteMeeting}
                    type="button"
                  >
                    Remove
                  </button>
                ) : null}
                <button className="btn-meeting btn px-4 py-2">
                  {type == "edit" ? "Update" : "Create"}{" "}
                </button>
              </div>
            </div>
            <div>
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <label>Title</label>
                      <div className="d-flex align-items-center mb-3">
                        <i className="bx bxs-pen position-absolute ps-3 fs-5 text-link"></i>
                        <input
                          value={addTitle}
                          onChange={(e) => setAddTitle(e.target.value)}
                          type="text"
                          placeholder="Add Title"
                          className="form-control ps-5"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      {/* <div className="col-md-5">
                        <label htmlFor="">Select Location</label>
                        <ReactSelect
                          value={crrlocation}
                          placeholder="Select Location"
                          className="basic-multi-select w-100 z-1"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={locations}
                          onChange={handleChangeLocation}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Select TimeZone</label>
                        <ReactSelect
                          defaultValue="Europe/London"
                          value={selectedTimeZone}
                          placeholder="Select Location"
                          className="basic-multi-select w-100 z-1"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={timeZonesWithLabelValue}
                          onChange={(selectedOption) =>
                            setSelectedTimeZone(selectedOption)
                          }
                        />
                      </div> */}
                      <div className="col-md-12">
                        <div className=" mt-2 gap-2 d-flex justify-content-between">
                          <div className="meetToggle">
                            <label className="mb-2">Online/Offline</label>
                            <div className="form-switch form-switch-md">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizemd"
                                defaultChecked={isImp == 1 ? true : false}
                                onChange={(e) =>
                                  setIsImp(e.target.checked ? 1 : 0)
                                }
                              />
                            </div>
                          </div>
                          <div className="mb-3 col-md-9">
                            {isImp == 1 ? (
                              <>
                                <label htmlFor="extraEmail">
                                  Add Meeting Link
                                </label>
                                <div className="d-flex gap-2 align-items-center">
                                  <input
                                    type="text"
                                    required
                                    className="form-control"
                                    placeholder="Enter Add Meeting Link"
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                  />
                                  {type == "edit" ? (
                                    <a
                                      className=""
                                      href={link}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <i className="fas fa-copy fs-4"></i>
                                    </a>
                                  ) : null}
                                </div>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="Attendees">
                        <label>
                          Attendees 
                        </label>
                        <div className="d-flex align-items-center mb-3">
                          <i className="bx bxs-user-plus  position-absolute ps-3 fs-4 text-link z-2"></i>
                          <ReactSelect
                            value={addAttendees}
                            placeholder="Select attendees"
                            className="basic-multi-select w-100 z-1"
                            classNamePrefix="select"
                            isMulti
                            styles={customStyles2}
                            options={attendOption}
                            onChange={(e) => handleChangeAttendees(e)}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center mb-3">
                          <div className="w-50 ">
                            <label>
                              Date <span className="text-danger">*</span>{" "}
                            </label>
                            <input
                              type="date"
                              required
                              value={addDate}
                              className="form-control"
                              onChange={(e) => setAddDate(e.target.value)}
                              min={getTodayDate()}
                            />
                          </div>
                          <div className="w-50 ps-3">
                            <label>
                              TimeSlots <span className="text-danger">*</span>{" "}
                            </label>

                            <ReactSelect
                              value={selectedTimeSlot}
                              placeholder="Select TimeSlots"
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={colourStyles}
                              options={timeSlotsOption}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex flex-column">
                        <div className="row mb-3">
                          <div className="col-6">
                            <label>
                              Meeting With{" "}
                              <span className="text-danger">*</span>{" "}
                            </label>
                            <ReactSelect
                              value={meetingFor}
                              placeholder="Select..."
                              className="basic-multi-select w-100 z-1"
                              classNamePrefix="select"
                              styles={colourStyles}
                              options={meetingForOption}
                              onChange={handleMeetingFor}
                            />
                          </div>
                          {ismeetingFor && (
                            <div className="col-6">
                              <label>
                                Select {meetingForLabel}{" "}
                                <span className="text-danger">*</span>{" "}
                              </label>
                              <ReactSelect
                                value={meetingForSubset}
                                placeholder={`select ${meetingForLabel}`}
                                className="basic-multi-select w-100 z-1"
                                classNamePrefix="select"
                                styles={colourStyles}
                                options={meetingForSub}
                                onChange={handleMeetingForSubset}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label>Description</label>
                  <div>
                    <textarea
                      name=""
                      id=""
                      className="w-100 form-control"
                      rows={5}
                      value={addDescription}
                      onChange={(e) => setAddDescription(e.target.value)}
                    ></textarea>
                  </div>
                </div>
                <div>
                  <div className="me-2 d-flex justify-content-end">
                    <button className="btn-meeting btn px-4 py-2">
                      {type == "edit" ? "Update" : "Create"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CalenderIndex;
